document.addEventListener("DOMContentLoaded", () => {
  // MegaMenu
  const megaMenus = document.querySelectorAll('.mega-menu');
  megaMenus.forEach(function(megaMenu) {
  megaMenu.addEventListener('mouseenter', function() {
    megaMenu.setAttribute('open', true);
  });

  megaMenu.addEventListener('mouseleave', function() {
    megaMenu.removeAttribute('open');
  });
});


  //Collection-tabs
  document.querySelectorAll(".collection-tabs__heading").forEach((tab) => {
    tab.addEventListener("click", function() {
      const wrapper = this.closest(".collection-tabs__wrapper");
      wrapper
        .querySelectorAll(".collection-tabs__content")
        .forEach((content) => {
          content.classList.remove("is--active");
        });
      wrapper
        .querySelectorAll(".collection-tabs__heading")
        .forEach((heading) => {
          heading.classList.remove("is-tab-active");
        });
      this.classList.add("is-tab-active");
      const selectedTab = this.dataset.tab;
      wrapper.querySelector("." + selectedTab).classList.add("is--active");
    });
  });
  // collection page svg

  let svgFullwidth = document.querySelector(".svg__1");
  let svgHalfwidth = document.querySelector(".svg__2");
  svgFullwidth?.addEventListener("click", function() {
    svgFullwidth.querySelector("svg").style.fill = "#FFF3CF";
    svgHalfwidth.querySelectorAll("svg rect").forEach((svg) => {
      svg.style.fill = "#FFF3CF";
    });
    document.querySelectorAll(".selected-product-button").forEach((event) => {
      event.style.maxWidth = "100%";
      event.style.width = "100%";
    });

    svgHalfwidth.addEventListener("click", function() {
      svgFullwidth.querySelector("svg").style.fill = "#FFF3CF";
      svgHalfwidth.querySelectorAll("svg rect").forEach((svg) => {
        svg.style.fill = "#FFF3CF";
      });
      document.querySelectorAll(".selected-product-button").forEach((event) => {
        event.style.maxWidth = "50%";
        event.style.width = "45%";
      });
    });
  });

  //mobile-sort

  document.addEventListener("click", (e) => {
    if (e.target.classList.contains('.mobile-sorting-option')) {
      let value = e.target.querySelector(".mobile-sorting-option").innerText;
      document.querySelector(".mobile-sorting-option").innerHTML = value;
    }
    if (e.target?.closest('li')?.classList.contains('sorting-values')) {
      elem = document.querySelectorAll('.sorting-values').forEach(elem => elem.classList.remove('is--active'))
      e.target.closest('li').classList.add('is--active');

      let value = e.target.querySelector(".mobile-sorting-option").innerText;
      document.querySelector(".mobile-sorting-option").innerHTML = value;
      console.log(value)

    }

    if (e.target?.classList.contains('mobile-facets-sort__close')) {
      document.querySelector(".mobile-sorting").style.display = "none";
    }
  });



  document.querySelector(".mobile-sorting-label")?.addEventListener("click", (e) => {
    document.querySelector(".mobile-sorting") ? document.querySelector(".mobile-sorting").style.display = "block" : null;
    document.querySelector(".background-popup") ? document.querySelector(".background-popup").style.display = "block" : null;
  });
  var elem = document.querySelectorAll(".sorting-values");
  elem.forEach((element) => {
    element.addEventListener("click", (e) => {
      elem.forEach((element) => {
        element.classList.remove("is--active");
      });
      element.classList.add("is--active");
      if (element.querySelector(".sorting-label-value")) {
        var value = element.querySelector(".sorting-label-value").innerText;
        document.querySelector(".mobile-sorting-option").innerHTML = value;
      }

      setTimeout(function() {
        document.querySelector(".mobile-sorting") ? document.querySelector(".mobile-sorting").style.display = "none" : null;
        document.querySelector(".background-popup") ? document.querySelector(".background-popup").style.display = "none" : null;
      }, 500);
    });
  });

  document.querySelector(".background-popup")?.addEventListener("click", (e) => {
    document.querySelector(".mobile-sorting") ? document.querySelector(".mobile-sorting").style.display = "none" : null;
    document.querySelector(".background-popup") ? document.querySelector(".background-popup").style.display = "none" : null;
  });
  document.querySelector(".mobile-facets-sort__close")?.addEventListener("click", (e) => {
    document.querySelector(".mobile-sorting") ? document.querySelector(".mobile-sorting").style.display = "none" : null;
    document.querySelector(".background-popup") ? document.querySelector(".background-popup").style.display = "none" : null;
  });
  // RAS Offers
  let mydiv = document.querySelectorAll('.hideme');
  let moreBtn = document.querySelector('.more-offer');
  let lessBtn = document.querySelector('.less-offer')
  moreBtn?.addEventListener("click", (e) => {
    moreBtn.style.display = "none";
    mydiv.forEach((element) => {
      element.style.display = "block";
    });
    lessBtn.style.display = "flex";
  });
  lessBtn?.addEventListener("click", (e) => {
    lessBtn.style.display = "none";
    mydiv.forEach((element) => {
      element.style.display = "none";
    });
    moreBtn.style.display = "flex";
  });

  // Build Your Routine
  document.querySelectorAll(".build-your-routine-tabs").forEach((tab) => {
    tab.addEventListener("click", function() {
      const wrapper = this.closest(".build-your-routine");
      wrapper.querySelectorAll(".build-your-routine_wrapper")
        .forEach((content) => {
          content.classList.remove("is--active");
        });
      wrapper.querySelectorAll(".build-your-routine-tabs")
        .forEach((heading) => {
          heading.classList.remove("is-tab-active");
        });
      this.classList.add("is-tab-active");
      const selectedTab = this.dataset.tab;
      wrapper.querySelectorAll("." + selectedTab).forEach((ele) => {
        ele.classList.add("is--active");
      });
    });
  });
  // SWATCHES
  document.querySelectorAll('.swatchs').forEach((element) => {
    element.addEventListener("click", (e) => {
        console.log(element.getAttribute('data-value'));
        document.querySelector('.form__label').innerHTML = element.getAttribute('data-value');
    });
    });
  document.querySelectorAll('.variant-all').forEach((element) => {
    element.addEventListener("click", (e) => {
        console.log(element.getAttribute('data-value'));
        document.querySelector('.form__label').innerHTML = element.getAttribute('data-value');
    });
    });
});